
import { validateSessionByCookie } from "../../services/cookies";
import { EventParams, ISelectItemItineraryEvent } from "./selectItem.dto";

export const handleSelectItemInItinerarySelection = (data, index): ISelectItemItineraryEvent => {

  const fareInfo = data.fares[0];
  const firstSegment = data.segments[0];
  const lastSegment = data.segments[data.segments.length - 1];
  const itemCategory = data.isOrigin ? "Tickets/vuelta" : "Tickets/ida";
  const date = data.isOrigin ? data.queryStore.arrivalDate : data.queryStore.departureDate;
  const fareOw = window.localStorage.getItem('currentBundle') ?? "";
  const fullTripFare = data.isOrigin ? `${fareOw}|${data.segments[0].bookingClass}` : data.segments[0].bookingClass;

  const hm = getHm(data);

  const ecommerce = createEcommerceObject(data, fareInfo, index, itemCategory, firstSegment, lastSegment, date);

  const eventParams: EventParams = {
    page_path: `/${hm}/flujo-compra/busqueda-vuelos`,
    micrositio: "booking",
    page_type: "Búsqueda de Vuelos",
    homemarket: hm,
    environment: data.env,
    negocio: "retail",
    login: validateSessionByCookie(),
    initial_date: data.queryStore.departureDate,
    end_date: data.queryStore.arrivalDate,
    from_iata: firstSegment.origin,
    to_iata: lastSegment.destination,
    trip_type: data.queryStore.flightType === 'RT' ? 'roundtrip' : 'oneway',
    buy_instance: "IS",
    corp: data.corp,
    app: data.app,
    passengers_adult: parseInt(data.queryStore.ADT),
    passengers_child: data.queryStore.CHD ? parseInt(data.queryStore.CHD) : 0,
    passengers_infant: data.queryStore.INF ? parseInt(data.queryStore.INF) : 0,
    passengers_pet: 0,
    pax: parseInt(data.queryStore.ADT) + (data.queryStore.CHD ? parseInt(data.queryStore.CHD) : 0) + (data.queryStore.INF ? parseInt(data.queryStore.INF) : 0),
    full_trip: `${firstSegment.origin}-${lastSegment.destination}`,
    exchange_rate: '',
    full_trip_dates: `${data.queryStore.departureDate}, ${data.queryStore.arrivalDate}`,
    full_trip_fare_basis: fullTripFare,
    pas_dni_hashed: '',
    birthday: '',
    ecommerce: {
      items: ecommerce
    }
  };

  return {
    event: "select_item",
    event_params: eventParams
  }
};

const createEcommerceObject = (data, fareInfo, i, itemCategory, firstSegment, lastSegment, date) => {
  const itemVariant = data.segments.length > 1 ? `${firstSegment.bookingClass}|${firstSegment.flight.flightNumber}|${lastSegment.flight.flightNumber}` : `${firstSegment.bookingClass}|${firstSegment.flight.flightNumber}`;
  return [{
    item_id: `${[data.queryStore.origin, data.queryStore.destination].sort().join('')}`,
    item_name: "Ticket",
    index: i + 1,
    item_category: itemCategory,
    fare_class: firstSegment.bookingClass,
    item_list_name: `${[data.queryStore.origin, data.queryStore.destination].sort().join('')}|IS`,
    item_variant: itemVariant,
    price: fareInfo.priceByPassengerTypes[0].fare.amount,
    quantity: parseInt(data.queryStore.ADT) + (data.queryStore.CHD ? parseInt(data.queryStore.CHD) : 0),
    tag_price: firstSegment.bookingClass,
    fare_basis: firstSegment.bookingClass,
    cabin: firstSegment.cabinClass.toLowerCase(),
    date: date
  }];
};

export const getHm = (data) => {
  const url = data.hm;
  const hm = url.split("/")[2];
  return hm;
};
